/** Verifica se o relatório médico foi assinado com certificado ICP-Brasil. */
export function isSignedMedicalReport(report?: {
  is_signed?: boolean;
  signature_provider?: string | null;
  status?: string;
} | null): boolean {
  if (!report) return false;
  return Boolean(
    report.is_signed
    || report.status === 'signed'
    || String(report.signature_provider || '').startsWith('icp_'),
  );
}
